import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
// React-table library requires to import css as well:
import ReactTable from 'react-table';
import 'react-table/react-table.css'; // eslint-disable-next-line
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core';
import HighlightOff from '@material-ui/icons/HighlightOff';
import {
  giorniSettimana,
  orariControlli,
} from '../../../../utils/constants.js';

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: '190px',
      // maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 270,
    },
  },
};
const styles = (theme) => ({
  formcontrol: {
    marginBottom: '30px',
    width: '270px',
    padding: '0px 4px',
  },
  container: {
    //maxWidth: "800px",
    padding: '0px 0px 20px 0px',
  },
  addButton: {
    color: theme.palette.text.main,
    margin: '10px',
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  tableContainer: {
    margin: '10px 0px 10px 0px',
    paddingBottom: '10px',
  },
});

class FormSettimanale extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cadenza: {
        orario: '08:00:00',
        giornoSettimana: 'MONDAY',
        mese: null,
        giornoMese: null,
        schedaId: null,
        id: null,
        controlloConformitaId: null,
      },
    };
  }

  onSelect = (event) => {
    this.handleChange(event.target.name, event.target.value);
  };

  handleChange = (name, value) => {
    let cadenza = JSON.parse(JSON.stringify(this.state.cadenza));
    cadenza[name] = value;

    this.setState({
      cadenza,
    });
  };

  render() {
    const { classes } = this.props;

    const columns = [
      {
        Header: 'ID',
        id: 'id',
        accessor: (d) => d.id,
        show: false,
      },
      {
        Header: 'Orario',
        id: 'orario',
        accessor: (d) => d.orario,
        minWidth: 104,
      },
      {
        Header: 'Giorno Settimana',
        id: 'giornoSettimana',
        accessor: (d) => d.giornoSettimana,
        minWidth: 104,
        Cell: (props) => {
          if (props.value !== null) {
            switch (props.value) {
              case 'MONDAY':
                return 'LUNEDÍ';
              case 'TUESDAY':
                return 'MARTEDÍ';
              case 'WEDNESDAY':
                return 'MERCOLEDÍ';
              case 'THURSDAY':
                return 'GIOVEDÍ';
              case 'FRIDAY':
                return 'VENERDÍ';
              case 'SATURDAY':
                return 'SABATO';
              case 'SUNDAY':
                return 'DOMENICA';
              default:
                return '-';
            }
          }
          return '-';
        },
      },
      {
        id: 'eliminaBtn',
        Header: 'Elimina',
        accessor: (row) => row,
        width: 90,
        Cell: (props) => (
          <IconButton
            size="small"
            disabled={false}
            onClick={() => {
              this.props.onDeleteCadenza(props.index);
            }}
            color="primary"
            title="Rimuovi cadenza"
          >
            <HighlightOff />
          </IconButton>
        ),
      },
    ];

    return (
      <Grid
        container
        justify="center"
        alignItems="center"
        className={classes.container}
      >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography variant="body1" style={{ fontWeight: 500 }} gutterBottom>
            Giorno e ora del controllo
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
          <Grid container justify="center">
            <FormControl className={classes.formcontrol}>
              <InputLabel id="giornoNotifica-label">
                Giorno del controllo
              </InputLabel>
              <Select
                labelId="giornoNotifica-label"
                value={this.state.cadenza.giornoSettimana}
                name="giornoSettimana"
                onChange={this.onSelect}
                MenuProps={MenuProps}
              >
                <MenuItem disabled value={''}>
                  <em>Seleziona un giorno</em>
                </MenuItem>
                {giorniSettimana.map((giornoSettimanale) => (
                  <MenuItem
                    key={giornoSettimanale.value}
                    value={giornoSettimanale.value}
                  >
                    {giornoSettimanale.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl className={classes.formcontrol}>
              <InputLabel id="orario-label">Ora del controllo</InputLabel>
              <Select
                labelId="orario-label"
                value={this.state.cadenza.orario}
                name="orario"
                onChange={this.onSelect}
                MenuProps={MenuProps}
              >
                <MenuItem disabled value={''}>
                  <em>Seleziona un orario</em>
                </MenuItem>
                {orariControlli.map((orario) => (
                  <MenuItem key={orario.value} value={orario.value}>
                    {orario.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl className={classes.formcontrol}>
              <Button
                size="small"
                onClick={() => this.props.onAddCadenza(this.state.cadenza)}
                variant="contained"
                disabled={false}
                className={classes.addButton}
              >
                Aggiungi
              </Button>
            </FormControl>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className={classes.tableContainer}
        >
          <ReactTable
            filterable={false}
            resizable={true}
            showPageSizeOptions={true}
            showPageJump={true}
            defaultPageSize={5}
            style={{
              height: 300,
              width: '100%',
            }}
            data={this.props.cadenze}
            columns={columns}
            previousText="Precedente"
            nextText="Successivo"
            noDataText="Nessun record"
            pageText="Pagina"
            ofText="di"
            rowsText="righe"
            pageJumpText="Vai a pagina"
            rowsSelectorText="righe per pagina"
          />
        </Grid>
      </Grid>
    );
  }
}

FormSettimanale.propTypes = {
  cadenze: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  onAddCadenza: PropTypes.func.isRequired,
  onDeleteCadenza: PropTypes.func.isRequired,
};

export default withStyles(styles)(FormSettimanale);
